import { FilteringHashed, FilteringItem, Filters } from '@3ddv/ngx-sites-builder-lib';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FiltersService } from '../services/filters.service';
import { SidebarService } from '../../../sb-editor-sidebar/services/sidebar.service';
import { Sidebar } from '../../../sb-editor-sidebar/models/sidebar.model';
import { FilteringItemPosition } from '../models/filtersUtils.model';
import { FilterPreviewItemComponent } from './filter-previewitem/filter-previewitem.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FilteringNewItem } from '../models/filtering.model';
import { Router } from '@angular/router';
@Component({
  selector: 'app-filter-generation',
  templateUrl: './filter-generation.component.html',
  styleUrls: ['./filter-generation.component.scss'],
})
export class FilterGenerationComponent implements OnInit, OnDestroy {
  @Input() tool: Filters;
  //public tool: Filters;
  public itemList: Array<FilteringItem>;
  public itemListHashed: FilteringHashed;

  // Dropdown
  /*   public dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  public dropdownData: Array<{ id: string; name: string }> = [];
  public dropdownSelected; */

  private subscriptions: Array<Subscription> = [];
  public newFilter: FilteringNewItem = {
    name: '',
    type: 'vip',
    color: '',
  };

  public generationMode: { mode: 'create' | 'edit' | null } = { mode: null };
  public itemToEdit: FilteringItem = null;
  public confirmDelete: boolean = false;
  @ViewChild('previewitem', { static: false }) previewitemComponent: FilterPreviewItemComponent;

  public sidebar: Sidebar;

  public previewFiltering = {
    show: true,
  };
  public bsModalRef: BsModalRef;

  constructor(
    private filtersService: FiltersService,
    private sidebarService: SidebarService,
    public changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.itemList = JSON.parse(JSON.stringify(this.tool.data));
    //this.dropdownData = this.generateDropdownData(this.itemList);
    this.itemListHashed = JSON.parse(JSON.stringify(this.tool.hashed));
    const sidebar$ = this.sidebarService.getAsyncSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebar$);

    const o$ = this.filtersService.getListAndHash$().subscribe(res => {
      this.itemList = res.data;
      this.itemListHashed = res.hash;
      this.tool.data = res.data;
      this.tool.hashed = res.hash;
    });
    this.subscriptions.push(o$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public fillAll() {
    this.tool.colors.filtered = '#fff';
    this.tool.colors.opacity = '0.7';
    this.tool.colors.stroke = '#fff';
    this.tool.colors.strokeOpacity = '0.7';
    this.tool.colors.lineWidth = '1';
    this.tool.colors.hover = '#fff';
    this.tool.colors.hoverOpacity = '1';
    this.tool.colors.hoverStroke = '#fff';
    this.tool.colors.hoverStrokeOpacity = '1';
    this.tool.colors.hoverLineWidth = '1';
    this.tool.colors.unavailable = '#000';
    this.tool.colors.unavailableOpacity = '0.4';
    this.tool.colors.unavailableStroke = '#000';
    this.tool.colors.unavailableStrokeOpacity = '0.4';
  }

  // on click edit filter button
  public editItem($event: FilteringItem) {
    this.generationMode.mode = 'edit';
    this.itemToEdit = Object.assign({}, $event);
  }

  public moveItem($move: FilteringItemPosition) {
    let found = this.itemList.filter(i => i.id === $move.id);
    if (!found.length) {
      this.filtersService.recursiveReOrderFilter($move, this.itemList);
    } else {
      // do parent
      let new_pos = 0;
      if ($move.action === 'up') {
        new_pos = $move.currentPosition - 1;
      } else if ($move.action === 'down') {
        new_pos = $move.currentPosition + 1;
      }
      const save_item_newpos = this.itemList[new_pos];
      this.itemList[new_pos] = found[0];
      this.itemList[$move.currentPosition] = save_item_newpos;
    }
    this.filtersService.setListAndHash$({
      data: this.itemList,
      hash: this.itemListHashed,
    });
  }

  public toggleGenerationMode(mode: 'create' | 'edit') {
    this.generationMode.mode = mode;
    this.itemListHashed = JSON.parse(JSON.stringify(this.tool.hashed));
    if (mode === 'create') {
      this.previewitemComponent.activeId = null;
      this.itemToEdit = null;
    }
  }

  // received on save
  public savedItem($event: FilteringItem) {
    this.generationMode.mode = null;
    this.previewitemComponent.activeId = null;
    this.itemToEdit = null;
  }

  public cancelItem($event: null) {
    this.generationMode.mode = null;
    this.previewitemComponent.activeId = null;
    this.itemToEdit = null;
    // console.log('cancel');
  }

  public getDefaultModeRegularColor() {
    // console.log(this.tool.integration.defaultmode.regular);
    if (this.tool.integration.defaultmode.regular) {
      this.tool.integration.defaultmode.regular = `#c1c1c1`;
    } else {
      this.tool.integration.defaultmode.regular = null;
    }
  }
}
